import React from 'react';

/**
 * Screenshot frame for the Features page.
 * With `src`: shows the image (lazy-loaded unless `priority`).
 * Without `src`: shows a labelled placeholder of the same size, so the layout
 * doesn't shift when the real screenshot is added.
 */
function Shot({ src, label, priority = false }) {
    return (
        <figure className="wqf-shot">
            {src ? (
                <img
                    src={src}
                    alt={label}
                    width="1600"
                    height="1000"
                    loading={priority ? 'eager' : 'lazy'}
                    decoding="async"
                    {...(priority ? { fetchpriority: 'high' } : {})}
                />
            ) : (
                <div className="wqf-shot-empty" role="img" aria-label={`${label} screenshot`}>
                    <span>{label}</span>
                </div>
            )}
        </figure>
    );
}

export default React.memo(Shot);
